<script setup>
import { useGlobalStore } from '@stores/global'
import { useStoreStore } from '@stores/store'
import { ref } from 'vue'

const global = useGlobalStore()
const store = useStoreStore()

const groups = ref([
	{
		title: '// sitemap',
		items: [
			{
				title: 'home',
				to: { name: 'index' },
			},
			{
				title: 'story',
				to: { name: 'story' },
			},
			{
				title: 'shop',
				to: { name: 'shop-list' },
			},
			// {
			// 	title: "bounty",
			// 	to: { name: "bounty" },
			// },
			{
				title: 'about',
				to: { name: 'about' },
			},
		],
	},
	{
		title: '// terms and policy',
		items: [
			{
				title: 'Privacy Policy',
				to: { name: 'page', params: { slug: 'privacy' } },
			},
			{
				title: 'Terms & Conditions',
				to: { name: 'page', params: { slug: 'terms' } },
			},
		],
	},
])

const date = new Date().getFullYear()
</script>

<template>
	<footer>
		<div class="relative z-lines flex flex-col-reverse overflow-hidden text-default lg:flex-row">
			<div class="text-defaultS leading-default z-images border-t border-border-default bg-bg lg:w-[50%] lg:p-8 lg:pb-0">
				<div class="flex flex-wrap gap-8 gap-x-16 border-b border-border-default p-8 lg:gap-16">
					<div v-for="group in groups" :key="group.title" class="flex flex-col gap-6">
						<span class="label-medium">{{ group.title }}</span>
						<p class="md flex flex-col gap-2 capitalize opacity-30">
							<router-link v-for="item in group.items" :key="item.title" :to="item.to">
								{{ item.title }}
							</router-link>
						</p>
					</div>
					<div class="flex flex-col gap-6" v-if="store.collections?.length">
						<span class="label-medium">// latest drop</span>
						<p class="md flex flex-col gap-2 capitalize opacity-30">
							<router-link v-for="collection in store.collections" :key="collection.title" :to="{ name: 'collection', params: { id: collection.slug } }">
								{{ collection.title }}
							</router-link>
						</p>
					</div>
				</div>
				<div class="flex items-center justify-between px-8 pb-6 pt-8">
					<i class="icon-logo text-[40px]" />
					<p class="text-sm opacity-30">{{ date }} Project ETHER. All rights reserved.</p>
				</div>
			</div>
			<div class="relative hidden w-[50%] bg-neutral-700 text-bg lg:flex">
				<i class="icon-logo absolute bottom-[-10vw] left-[-4vw] text-[480px]" />
			</div>
		</div>
	</footer>
</template>
